module.exports = __webpack_public_path__ + "9360aa3835b57ace5e97c989daa3310c.png";